import {NgModule} from '@angular/core';
import {AssetModule, AssetService} from '../../components/asset';
import {DistributedStreamingRegistryService, StreamingModule} from '../../components/streaming';
import {SubscriptionStreamingService} from '../../components/streaming/subscription-streaming.service';
import {UserDataStreamingService} from './user-data-streaming.service';

@NgModule({
    imports: [
        StreamingModule,
        AssetModule
    ],
    providers: [
        {
            provide: UserDataStreamingService,
            useFactory: (
                         distributedStreamingRegistryService: DistributedStreamingRegistryService
                     ) => {
                const injector = distributedStreamingRegistryService
                    .getStreamingServiceInjector('userDataStreaming');

                return new UserDataStreamingService(
                    injector.get(SubscriptionStreamingService),
                    injector.get(AssetService)
                );
            },
            deps: [DistributedStreamingRegistryService]
        }

        // [HED-930] Not used in DEX
        // OrderStreamingService,
        // PositionsStreamingService,
        // InactiveAccountStreamingService
    ]
})
export class UserDataStreamingModule {}
